import {
    PRICE_RULES_REQUEST,
    PRICE_RULES_SUCCESS,
    PRICE_RULES_FAILURE,
    ADD_PRICE_RULE_REQUEST,
    ADD_PRICE_RULE_SUCCESS,
    ADD_PRICE_RULE_FAILURE,
    DELETE_PRICE_RULE_REQUEST,
    DELETE_PRICE_RULE_SUCCESS,
    DELETE_PRICE_RULE_FAILURE,
    UPDATE_PRICE_RULE_REQUEST,
    UPDATE_PRICE_RULE_SUCCESS,
    UPDATE_PRICE_RULE_FAILURE,
    ASSIGN_PRICE_RULE_TO_CATEGORIES_REQUEST,
    ASSIGN_PRICE_RULE_TO_CATEGORIES_SUCCESS,
    ASSIGN_PRICE_RULE_TO_CATEGORIES_FAILURE,
    GET_CATEGORIES_BY_PRICERULE_REQUEST,
    GET_CATEGORIES_BY_PRICERULE_SUCCESS,
    GET_CATEGORIES_BY_PRICERULE_FAILURE
} from '../actions/priceRuleActions';

const initialState = {
    priceRules: [],
    loading: false,
    error: null,
    totalCount: 0,
    totalPages: 0,
    categoriesByRule: [],
    categoriesLoading: false,
    categoriesError: null,
    assignLoading: false,
    assignError: null
};

const priceRuleReducer = (state = initialState, action) => {
    switch (action.type) {
        case PRICE_RULES_REQUEST:
        case ADD_PRICE_RULE_REQUEST:
        case DELETE_PRICE_RULE_REQUEST:
        case UPDATE_PRICE_RULE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case PRICE_RULES_SUCCESS:
            return {
                ...state,
                loading: false,
                priceRules: Array.isArray(action.payload.data) ? action.payload.data : [],
                totalCount: action.payload.recordsTotal || 0,
                totalPages: Math.ceil((action.payload.recordsTotal || 0) / 10)
            };
        case ADD_PRICE_RULE_SUCCESS:
            return {
                ...state,
                loading: false,
                priceRules: [...state.priceRules, action.payload]
            };
        case UPDATE_PRICE_RULE_SUCCESS:
            return {
                ...state,
                loading: false,
                priceRules: state.priceRules.map(rule =>
                    rule.id === action.payload.id ? action.payload : rule
                )
            };
        case DELETE_PRICE_RULE_SUCCESS:
            return {
                ...state,
                loading: false,
                priceRules: state.priceRules.filter(rule => rule.id !== action.payload)
            };
        case PRICE_RULES_FAILURE:
        case ADD_PRICE_RULE_FAILURE:
        case DELETE_PRICE_RULE_FAILURE:
        case UPDATE_PRICE_RULE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        case GET_CATEGORIES_BY_PRICERULE_REQUEST:
            return {
                ...state,
                categoriesLoading: true,
                categoriesError: null
            };
        case GET_CATEGORIES_BY_PRICERULE_SUCCESS:
            return {
                ...state,
                categoriesLoading: false,
                categoriesByRule: action.payload || []
            };
        case GET_CATEGORIES_BY_PRICERULE_FAILURE:
            return {
                ...state,
                categoriesLoading: false,
                categoriesError: action.payload
            };
        case ASSIGN_PRICE_RULE_TO_CATEGORIES_REQUEST:
            return {
                ...state,
                assignLoading: true,
                assignError: null
            };
        case ASSIGN_PRICE_RULE_TO_CATEGORIES_SUCCESS:
            return {
                ...state,
                assignLoading: false
            };
        case ASSIGN_PRICE_RULE_TO_CATEGORIES_FAILURE:
            return {
                ...state,
                assignLoading: false,
                assignError: action.payload
            };
        default:
            return state;
    }
};

export default priceRuleReducer; 